import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { useAppStore } from "@/ts/stores/app";
import { useViewportUtilities } from "@/ts/utils/viewport-utilities";
import { useAnchorEvents } from "@/ts/utils/anchor-events";
import Player from "@vimeo/player";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

useViewportUtilities();
useAnchorEvents();

const appStore = useAppStore();

onMounted(() => {
    const iframe = document.querySelector('iframe[src*="vimeo"]') as HTMLIFrameElement;
    if (iframe) {
        const player = new Player(iframe);

        player.on("play", () => {
            iframe.classList.remove("opacity-0");
        });
    }
    appStore.indexPages();
});

const __returned__ = { appStore, onMounted, get useAppStore() { return useAppStore }, get useViewportUtilities() { return useViewportUtilities }, get useAnchorEvents() { return useAnchorEvents }, get Player() { return Player } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})